import { IonButton } from "@ionic/react";

export const FormButtonSubmit: React.FC = () => {
  return (
    <IonButton type="submit" expand="block" style={{ marginTop: 40 }}>
      Recuperar
    </IonButton>
  );
};
